<template>
  <div>
    <el-button @click="manageTaxInfo">管理发票信息</el-button>
    <!-- 管理发票信息 -->
    <el-dialog title="管理发票信息" :visible.sync="manageVisible" width="500px" @close="closeDialog">
      <el-form ref="taxInfoForm" label-width="100px" label-position="right" :model="form" :rules="rules" label-suffix="：">
        <el-form-item label="发票类型" prop="invoiceType">
          <el-radio :label="1" v-model="form.invoiceType">增值税普通发票</el-radio>
          <el-radio :label="2" v-model="form.invoiceType">增值税专用发票</el-radio>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoiceTitle">
          <el-input type="input" v-model="form.invoiceTitle" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="taxNumber">
          <el-input type="input" v-model="form.taxNumber" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="bankName">
          <el-input type="input" v-model="form.bankName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="accountNumber">
          <el-input type="input" v-model="form.accountNumber" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="address">
          <el-input type="input" v-model="form.address" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="注册电话" prop="phone">
          <el-input type="input" v-model="form.phone" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="receiveUserName">
          <el-input type="input" v-model="form.receiveUserName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="receiveUserPhone">
          <el-input type="input" v-model="form.receiveUserPhone" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="收票邮箱" prop="email">
          <el-input type="input" v-model="form.email" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="收票地址" prop="receiveAddress">
          <el-input type="input" v-model="form.receiveAddress" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="plain" @click="manageVisible = false">取消</el-button>
        <el-button type="primary" @click="saveInvoiceInfo">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script  >
import InvoiceService from "@/apis/InvoiceService";
import { Message } from "element-ui";

export default {
  data() {
    return {
      manageVisible: false,
      form: {
        id: 0,
        invoiceType: null,
        invoiceTitle: "",
        taxNumber: "",
        bankName: "",
        accountNumber: "",
        address: "",
        phone: "",
        receiveUserName: "",
        receiveUserPhone: "",
        email: "",
        receiveAddress: "",
      },
      rules: {
        invoiceType: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "change" }
        ],
        taxNumber: [
          { required: true, message: "请输入税号", trigger: "change" }
        ],
        receiveUserName: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        receiveUserPhone: [
          { required: true, message: "请输入联系方式", trigger: "change" }
        ],
        email: [
          { required: true, message: "请输入收票邮箱", trigger: "change" }
        ],
        receiveAddress: [
          { required: true, message: "请输入收票地址", trigger: "change" }
        ],
      },
    }
  },
  methods: {
    manageTaxInfo() {
      this.manageVisible = true;
      InvoiceService.getInvoiceTaxInfo().then(res => {
        if (res) {
          for (const key in this.form) {
            this.form[key] = res[key]
          }
        }
      })
    },
    closeDialog() {
      this.manageVisible = false;
      this.$refs.taxInfoForm.clearValidate();
    },
    async saveInvoiceInfo() {
      await this.$refs.taxInfoForm.validate();
      InvoiceService.saveInvoiceTaxInfo(this.form).then(res => {
        if (res) {
          Message.success("发票信息保存成功！");
          InvoiceService.invoiceTaxInfo = this.form;
          this.closeDialog();
        }
      })
    }
  }
};
</script>
<style lang="scss">
.dialog-footer {
  text-align: right;
}
</style>